import React from "react";
import { ImWhatsapp } from "react-icons/im";
import { getLeadSourceLine } from "../utils/waSource";
import "../floatingWhatsApp.css";

const PHONE = "5491128181122";

const FloatingWhatsApp = () => {
  const handleClick = () => {
    const sourceLine = getLeadSourceLine();

    const lines = [
      "¡Hola! Estoy viendo la web de Lifting Store y tengo una consulta.",
      sourceLine,
    ].filter(Boolean);

    const url = `https://wa.me/${PHONE}?text=${encodeURIComponent(
      lines.join("\n")
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      className="floating-whatsapp"
      onClick={handleClick}
      aria-label="Hablar por WhatsApp"
    >
      <ImWhatsapp size={28} />
    </button>
  );
};

export default FloatingWhatsApp;
